var path = '/components/settings/settings.component.html';
var html = "<div class=\"row\">\n\t<div class=\"col-xs-12 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4\">\n\t\t<scenes></scenes>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;